import React, {useEffect, useState} from 'react';
import Box from '@mui/material/Box';
import {
  getNewDriveBannerData,
  talentBridgeContants,
  extractDate,
  AdsSlot,
  parseDayMonthString,
} from './utils';
import {useWrappedTheme} from '@jobseeker/lotus/lib/hooks';

const TalentBridgeTopBanner: React.FC = () => {
  const [date, setDate] = useState<string | null>(null);
  const theme = useWrappedTheme();

  useEffect(() => {
    const fetchBanner = async () => {
      try {
        const obj = await getNewDriveBannerData(AdsSlot.LANDING_PAGE_IMAGE);
        if (!Array.isArray(obj) || obj.length === 0) return;
        const extractedDate = extractDate(obj[0]?.subText || '');
        setDate(extractedDate);
      } catch (err) {
        console.error('Error fetching drive banner data:', err);
      }
    };
    fetchBanner();
  }, []);

  let showBanner = false;
  if (date) {
    const CURRENT_DATE = new Date();
    const year = new Date().getFullYear();
    const eventDate = parseDayMonthString(date, year);
    if (eventDate) {
      const showFrom = new Date(eventDate);
      showFrom.setDate(eventDate.getDate() - 20); // Show 20 days before event
      const hideAfter = new Date(eventDate);
      hideAfter.setDate(eventDate.getDate() + 1); // Hide 1 day after event
      showBanner = CURRENT_DATE >= showFrom && CURRENT_DATE < hideAfter;
    }
  }
  if (!showBanner) return null;

  return (
    <Box
      sx={{
        width: 'auto',
        height: 'auto',
        minHeight: 50,
        padding: 1.125, // 9px
        backgroundColor: 'secondary.main',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Box
        sx={{
          width: 'auto',
          height: 'auto',
          margin: '5px 10px 5px 0',
          fontSize: theme.typography.pxToRem(16),
          fontWeight: 600,
          fontStretch: 'normal',
          fontStyle: 'normal',
          lineHeight: 'normal',
          letterSpacing: 'normal',
          color: '#fff',
          '& span': {
            fontWeight: 800,
          },
        }}
      >
        <span>Hirist Talent Bridge</span> – Live Hiring Drive{' '}
        {date ? `on ${date}` : ''}
      </Box>
      <Box
        component={'a'}
        href={`/talent-bridge-hiring-drive?ref=${talentBridgeContants.refCode_temp}`}
        sx={{
          width: 'auto',
          maxWidth: 123,
          minHeight: 32,
          margin: '0 0 0 10px',
          padding: '7px 11px',
          borderRadius: 1,
          backgroundColor: 'primary.main',
          fontSize: theme.typography.pxToRem(13),
          fontWeight: 'bold',
          color: '#fff',
          border: 'none',
          outline: 'none',
          cursor: 'pointer',
          boxShadow: 'none',
          textDecoration: 'none',
          '&:hover': {
            backgroundColor: 'primary.dark',
            boxShadow: 'none',
          },
        }}
      >
        Register Now
      </Box>
    </Box>
  );
};

export default TalentBridgeTopBanner;
